import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setIdLineUp, setPitchLineupTemplate } from '../actions';
import RaisedButton from 'material-ui/RaisedButton';

function CreateTemplateBtn({ setIdLineUp, setPitchLineupTemplate }) {
    return (
        <RaisedButton
            label="Create Template"
            onClick={() => {
                const idLineUp = Math.floor(10000 + Math.random() * 90000);
                const ttId = new URL(location.href).searchParams.get('ttId');

                history.pushState({}, '', `?${ttId ? `ttId=${ttId}&` : ''}idLineUp=${idLineUp}`);
                setIdLineUp(idLineUp);
                setPitchLineupTemplate([]);
            }}
        />
    );
}

CreateTemplateBtn.propTypes = {
    // From connect
    setIdLineUp: PropTypes.func.isRequired,
    setPitchLineupTemplate: PropTypes.func.isRequired
};

export default connect(
    null,
    { setIdLineUp, setPitchLineupTemplate }
)(CreateTemplateBtn);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/CreateTemplateBtn.js
 **/